module.exports = new __parcel__URL__("BrickBoard.2aba3766.avif").toString();